<app-entity-profile-card
  *ngIf="outlet && showOutletProfile"
  [name]="outlet.name"
  [picture]="picture"
>
  <app-entity-follow-header
    profileTitle
    [name]="outlet.name"
    [active]="isOutletSaved"
    [ignored]="isOutletIgnored"
    [allowIgnore]="true"
    [labels]="shortcutLabels"
    [activeLabel]="outletLabel"
    [isLoading]="isAddedingOrIsRemoving"
    (toggled)="handleSaveOutlet(outlet)"
    (ignoreToggled)="handleIgnoreOutlet($event)"
    (labelToggled)="handleOutletLabel($event)"
  ></app-entity-follow-header>
  <ul
    class="entity-profile__contacts"
    profileContacts
    aria-label="Outlet details and links"
  >
    <li
      *ngIf="hasReportingAccess() && outlet.geoScore"
      class="entity-profile__metric"
      pTooltip="Measures how likely an outlet’s coverage is to influence AI-generated answers, blending independently calibrated ChatGPT, Gemini, and Claude evaluations of authority, accessibility, retrievability, and persistence."
    >
      <i class="pi pi-sitemap" aria-hidden="true"></i
      ><span>GEO {{ outlet.geoScore }}%</span>
    </li>
    <li *ngIf="outlet.webSiteUrl">
      <a [href]="outlet.webSiteUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-globe" aria-hidden="true"></i><span>Website</span>
      </a>
    </li>
    <li *ngIf="outlet.twitterUrl && outlet.twitterUrl != 'cbf'">
      <a [href]="outlet.twitterUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-twitter" aria-hidden="true"></i><span>X</span>
      </a>
    </li>
    <li *ngIf="outlet.linkedInUrl && outlet.linkedInUrl != 'cbf'">
      <a [href]="outlet.linkedInUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-linkedin" aria-hidden="true"></i><span>LinkedIn</span>
      </a>
    </li>
    <li *ngIf="outlet.youTubeUrl && outlet.youTubeUrl != 'cbf'">
      <a [href]="outlet.youTubeUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-youtube" aria-hidden="true"></i><span>YouTube</span>
      </a>
    </li>
  </ul>
  <div
    class="entity-profile__stats"
    profileStats
    *ngIf="hasReportingAccess() && outlet.myCompanyStats?.numItems > 0"
  >
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <span
      >Mentioned <strong>{{ project?.name }}</strong>&nbsp;
      <strong>{{ outlet.myCompanyStats.numItems }}</strong> times, most recently
      on <strong>{{ outlet.myCompanyStats.maxDate | date }}</strong></span
    >
  </div>
</app-entity-profile-card>
